module.exports = __webpack_public_path__ + "static/media/tutorial-banner.65144dc3.png";